import { NavLink } from 'react-router-dom';

const MENU = [
	{
		name: 'Dashboard',
		url: '/dashboard',
		icon: '/assets/shared/dashboard.svg',
		iconActive: '/assets/shared/dashboard-active.svg'
	},
	// {
	// name: 'Agents',
	// url: '/agents',
	// icon: '/assets/shared/agents.svg',
	// iconActive: '/assets/shared/agents-active.svg'
	// }
]

const Menu = () => {
	return (
		<div className="flex flex-wrap w-full bg-gray-100 dark:bg-bgColor-darkMode py-1 my-3 rounded-3xl">
			{MENU.map(menu => (
				<NavLink 
					key={menu.name} 
					className={({ isActive }) => `w-full text-center p-2 rounded-3xl ${isActive ? 'bg-primary-default' : 'dark:bg-black'}`.trim()}
					to={menu.url}
				>
					{({ isActive }) => (
						<div className='flex items-center justify-center text-base font-medium'>
							<img
								src={isActive ? menu.iconActive : menu.icon}
								alt={menu.name} 
								className="w-6 h-6 mr-2"
							/>
							<span className={isActive ? 'text-white' : 'text-gray-700'}>{menu.name}</span>
						</div>
					)}
				</NavLink>
			))}
		</div>
	)
}

export default Menu;